<template>
  <div class="services-table">
    <ServiceSelector
      ref='serviceSelector'
      :id_patient="patient.main.id_patient"
      :services="availableServices"
      @close="updatePatient"
    />
    <QrPaymentDialog
      ref='paymentDialog'
      :id_patient="patient.main.id_patient"
      @close="updatePaymentInfo"
    />
    <section class="btns-column">
      <mcw-button
        v-if="isServiceAdditingAllowed"
        @click.stop="showServiceEditModal"
        raised
        :disabled="processing"
        class="service-selector-btn"
      >
          <mcw-circular-progress
            v-if="processing"
            medium
            density="-8"
          />
        <mcw-material-icon v-else icon="edit" class="edit-icon"/>
        <span>
          Изменить услуги
        </span>
      </mcw-button>
      <mcw-button
        v-if="patient?.main.status !== 'Отменен'"
        @click.stop="showQrPaymentModal"
        raised
        class="service-selector-btn"
      >
        <mcw-material-icon icon="shopping_cart_checkout" class="edit-icon"/>
        <span>
          QR-код для оплаты
        </span>
      </mcw-button>
      <p
        style="color:red;margin:0.5rem 0;"
        v-if="areUnconfirmed && isServiceAdditingAllowed"
      >
        Есть неподтвержденные услуги на добавление
      </p>
    </section>
    <mcw-data-table v-if="items.length">
      <table class="mdc-data-table__table">
        <thead>
          <tr class="mdc-data-table__header-row">
          </tr>
        </thead>
        <tbody class="mdc-data-table__content">
          <tr class="mdc-data-table__row" v-for="item in items" :key="item.id_service">
            <td class="mdc-data-table__cell">{{item.id_service}}</td>
            <ExpandableCell :content="item.short_name" maxWidth="150"/>
            <!-- <td class="mdc-data-table__cell">{{item.short_name}}</td> -->
            <td class="mdc-data-table__cell">{{item.date_add}}</td>
            <td class="mdc-data-table__cell" v-if="userRank >= 100">{{item.price}}</td>
          </tr>
        </tbody>
      </table>
    </mcw-data-table>
  </div>
</template>

<script>
import ExpandableCell from './ExpandableCell.vue';
import QrPaymentDialog from './QrPaymentDialog.vue';
import ServiceSelector from './ServiceSelector.vue';

export default {
  name: 'ServicesTable',
  emits: ['updateServices'],
  props: {
    services: {
      type: String,
      default: '[]',
    },
    patient: {
      type: Object,
      default: () => null,
    },
  },
  components: {
    ExpandableCell,
    ServiceSelector,
    QrPaymentDialog,
  },
  data() {
    return {
      items: [],
      availableServices: [],
      filterString: '',
      processing: false,
    };
  },
  async mounted() {
    this.items = JSON.parse(this.services);
    if (this.patient?.main.id_patient) {
      this.updateServices();
    }
  },
  computed: {
    userRank() {
      return this.$store.getters['user/getUserRank'];
    },
    isServiceAdditingAllowed() {
      const pc = this.patient.add.id_contract;
      const contracts = this.$store.getters['contractsData/getContracts'];
      const result = contracts.find((i) => i.id_contract === pc)?.allow_service_add;
      return (result || this.userRank >= 100) && this.patient?.main.status === 'В ожидании';
    },
    areUnconfirmed() {
      return this.availableServices.some((i) => i.is_temp);
    },
  },
  methods: {
    async updateServices() {
      try {
        this.processing = true;
        this.availableServices = await this.$store.dispatch('employeesData/getHazardServices', { id_patient: this.patient.main.id_patient });
      } catch (err) {
        console.error(err);
      } finally {
        this.processing = false;
      }
    },
    async updatePatient() {
      this.updateServices();
      this.$emit('updateServices');
    },
    showServiceEditModal() {
      if (this.$refs.serviceSelector) {
        this.$refs.serviceSelector.open();
      }
    },
    showQrPaymentModal() {
      if (this.$refs.paymentDialog) {
        this.$refs.paymentDialog.open();
      }
    },
    updatePaymentInfo() {
      console.log('YAY');
    },
  },
};
</script>

<style>
.services-table .mdc-data-table{
  top: -14px;
}
.edit-icon {
  color: #fff !important;
  margin-right: 0.25rem;
}
.service-selector-btn {
  margin-bottom: 0.25rem;
}
.btns-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
